export const LS_CONTINUED_KEY = 'connect-version-continued';
export const LS_CONNECT_APP_ID = 'connect-app-id';
export const LS_LOG_KEY = 'aspera-log-level';
export const LS_CONNECT_DETECTED = 'aspera-last-detected';
